import * as React from "react";
import { ContentProps } from "../../../typings";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkSticky } from "uitk-react-sticky";
import { UitkText } from "uitk-react-text";
import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutConditionalGridSpan,
  UitkLayoutGridColumnRow,
} from "uitk-react-layout-grid";
import { ViewExtraLarge, ViewLarge, Viewport } from "bernie-view";
import { formatText } from "bernie-l10n";

export const CitiDesktopStickyBar = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];
  const imageClassNames = "uitk-type-right all-t-padding-four all-b-padding-two";
  const textClassNames = "uitk-type-left all-t-padding-six all-l-padding-three";
  const buttonClassNames = "uitk-type-center all-t-padding-six ";
  const separatorClassNames = "uitk-type-center all-l-margin-twelve";
  const imageColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 2, large: 2, extra_large: 2 };
  const textColSpan: UitkLayoutConditionalGridSpan = { small: 4, medium: 4, large: 4, extra_large: 4 };
  const separatorColSpan: UitkLayoutConditionalGridSpan = { small: 1, medium: 1, large: 1, extra_large: 1 };
  const buttonColSpan: UitkLayoutConditionalGridSpan = { small: 3, medium: 3, large: 3, extra_large: 3 };
  const gridColumns = {
    extra_large: 12 as UitkLayoutGridColumnRow,
    large: 12 as UitkLayoutGridColumnRow,
    medium: 12 as UitkLayoutGridColumnRow,
    small: 12 as UitkLayoutGridColumnRow,
  };

  if (!model || items.length !== 5) {
    return null;
  }
  const [feeText, separator, feeImage, noFeeImage, noFeeText] = items.map((item) => decorateEditorialHtml(item.text));
  const applyNowText = formatText("grid3.citiDesktopStickybar.applyNow.text");

  return (
    <Viewport>
      <ViewExtraLarge>
        <UitkSticky hidden={true} zIndex={1}>
          <div className="uitk-cell background-color-white">
            <UitkLayoutGrid columns={{ auto_fill: "sixteen" }}>
              <UitkLayoutGridItem colSpan={imageColSpan}>
                <div>
                  <div className={imageClassNames} dangerouslySetInnerHTML={feeImage} />
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={textColSpan}>
                <div>
                  <UitkText align="left" size={400} weight="bold">
                    <div className={textClassNames} dangerouslySetInnerHTML={feeText} />
                  </UitkText>
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={imageColSpan}>
                <div className={buttonClassNames}>
                  <UitkPrimaryButton type="button" text={applyNowText} />
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={separatorColSpan}>
                <div>
                  <div className={separatorClassNames} dangerouslySetInnerHTML={separator} />
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={imageColSpan}>
                <div>
                  <div className={imageClassNames} dangerouslySetInnerHTML={noFeeImage} />
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={textColSpan}>
                <div>
                  <UitkText align="left" size={400} weight="bold">
                    <div className={textClassNames} dangerouslySetInnerHTML={noFeeText} />
                  </UitkText>
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={buttonColSpan}>
                <div className={buttonClassNames}>
                  <UitkPrimaryButton type="button" text={applyNowText} />
                </div>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </div>
        </UitkSticky>
      </ViewExtraLarge>

      <ViewLarge>
        <UitkSticky hidden={true} zIndex={1}>
          <div className="uitk-cell background-color-white withBorder">
            <UitkLayoutGrid columns={gridColumns}>
              <UitkLayoutGridItem colSpan={separatorColSpan}>
                <div>
                  <div className={imageClassNames} dangerouslySetInnerHTML={feeImage} />
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={buttonColSpan}>
                <div>
                  <UitkText align="left" size={400} weight="bold">
                    <div className={textClassNames} dangerouslySetInnerHTML={feeText} />
                  </UitkText>
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={imageColSpan}>
                <div className={buttonClassNames}>
                  <UitkPrimaryButton type="button" text={applyNowText} />
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={separatorColSpan}>
                <div>
                  <div className="uitk-type-center all-l-margin-six" dangerouslySetInnerHTML={separator} />
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={separatorColSpan}>
                <div>
                  <div className={imageClassNames} dangerouslySetInnerHTML={noFeeImage} />
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={imageColSpan}>
                <div>
                  <UitkText align="left" size={400} weight="bold">
                    <div className={textClassNames} dangerouslySetInnerHTML={noFeeText} />
                  </UitkText>
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={imageColSpan}>
                <div className={buttonClassNames}>
                  <UitkPrimaryButton type="button" text={applyNowText} />
                </div>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </div>
        </UitkSticky>
      </ViewLarge>
    </Viewport>
  );
};

export default CitiDesktopStickyBar;
